"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = exports.decode = exports.EncodeError = exports.DecodeError = exports.HEADER_SIZE = void 0;
const resource_1 = __importDefault(require("./resource"));
const binary_1 = require("./utils/binary");
exports.HEADER_SIZE = 28;
class DecodeError extends Error {
    constructor(resourceId, msg) {
        super(`Error while decoding ${resourceId}: ${msg}`);
        Object.setPrototypeOf(this, DecodeError.prototype);
    }
}
exports.DecodeError = DecodeError;
class EncodeError extends Error {
    constructor(resourceId, msg) {
        super(`Error while encoding ${resourceId}: ${msg}`);
        Object.setPrototypeOf(this, EncodeError.prototype);
    }
}
exports.EncodeError = EncodeError;
/**
 * Decode a Picard resource binary from provided ArrayBuffer
 * @param resourceId Resource Id used to check if the decoded binary is correct
 * @param arrayBuffer ArrayBuffer to decode
 * @returns Decoded resource
 */
function decode(resourceId, arrayBuffer) {
    if (arrayBuffer.byteLength < exports.HEADER_SIZE) {
        throw new DecodeError(resourceId, "Binary file is missing header");
    }
    const dataView = new DataView(arrayBuffer);
    // Check magic number first
    const magicNumber = dataView.getUint8(0);
    if (magicNumber !== 0x1f) {
        throw new DecodeError(resourceId, `Magic Number is wrong. Decoded ${magicNumber}, expected ${0x1f}`);
    }
    const decodedResourceId = (0, binary_1.decodeResourceId)(dataView);
    if (decodedResourceId !== resourceId) {
        throw new DecodeError(resourceId, `Decoded incorrect resourceId, ${decodedResourceId}`);
    }
    const classifier = (0, binary_1.decodeClassifier)(dataView);
    const interval = dataView.getInt32(18) * 1000;
    const startTime = dataView.getInt32(22) * 1000;
    const dataType = (0, binary_1.decodeDataType)(dataView);
    // Remaining data represents the data array
    const binaryData = arrayBuffer.slice(exports.HEADER_SIZE, arrayBuffer.byteLength);
    // Construct the resource from attributes and data
    return new resource_1.default(resourceId, classifier, interval, startTime, dataType, binaryData);
}
exports.decode = decode;
/**
 * Encode a resource into the Picard resource binary format
 * @param resource Resource to encode
 * @returns ArrayBuffer with encoded binary data
 */
function encode(resource) {
    // Retrieve the data type of the resource's data
    const dataType = resource.dataType;
    // Allocate space
    const dataBuffer = new ArrayBuffer(exports.HEADER_SIZE + resource.count * dataType.bytes);
    const dataView = new DataView(dataBuffer);
    // Set magic number
    dataView.setUint8(0, 0x1f);
    (0, binary_1.encodeResourceId)(dataView, resource.resourceId);
    (0, binary_1.encodeClassifier)(dataView, resource.classifier);
    dataView.setInt32(18, resource.interval / 1000);
    dataView.setInt32(22, resource.startTime / 1000);
    dataView.setUint8(26, dataType.bytes); // TODO: Not currently used
    (0, binary_1.encodeDataType)(dataView, dataType);
    // Create an offset view for encoding points
    const readingsDataView = new DataView(dataBuffer, exports.HEADER_SIZE);
    const points = resource.points();
    // Perform extra checks to ensure that data is sequential and in order
    let expectedTimestamp = resource.firstReadingTime;
    for (const [i, [ts, value]] of points.entries()) {
        if (ts !== expectedTimestamp) {
            throw new EncodeError(resource.resourceId, `Unexpected timestamp. Encoding: ${ts} Expected: ${expectedTimestamp}`);
        }
        (0, binary_1.encodeReading)(readingsDataView, dataType, i, value); // Encode nulls as 0
        expectedTimestamp += resource.interval;
    }
    return dataBuffer;
}
exports.encode = encode;
//# sourceMappingURL=binary.js.map